import { Injectable } from '@angular/core';

import * as _ from 'lodash';
import { filter } from 'rxjs';

import { Store } from '@ngrx/store';

import { selectChatState, selectUser } from '../../../store/app.selectors';

import { IWorkspace, WorkspaceFeatures } from '../../../modules/chat/interfaces/IWorkspace';
import { IUserProfile } from '../../user/interfaces/IUserProfile';
import { EUserPermissions } from '../interfaces/EPermissions';
import { ChannelFeatures, IChannel } from '../interfaces/IChannel';
import { DealerSettingName, IDealerSetting } from '../interfaces/IDealerSettings';
import { AppStateWithChat } from '../store/chat.reducer';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  user: IUserProfile | null = null;
  selectedWorkSpace: IWorkspace | null = null;
  selectedChannel: IChannel | null = null;

  constructor(private store: Store<AppStateWithChat>) {
    this.setUserSubscription();
    this.setChatSubscription();
  }

  setChatSubscription(): void {
    this.store
      .select(selectChatState)
      .pipe(filter((data) => data !== undefined))
      .subscribe(({ selectedWorkSpace, selectedChannel }) => {
        this.selectedWorkSpace = selectedWorkSpace;
        this.selectedChannel = selectedChannel;
      });
  }

  setUserSubscription(): void {
    this.store.select(selectUser).subscribe((user) => {
      this.user = user;
    });
  }

  checkDealerSetting(setting: DealerSettingName, dealerSettings: IDealerSetting[] | null = null): boolean {
    if (!dealerSettings) {
      dealerSettings = this.user?.dealerSettings || [];
    }
    return _.find(dealerSettings, { key: setting, value: 'true' }) ? true : false;
  }

  checkWorkspaceFeatures(features: WorkspaceFeatures[], workspace: IWorkspace | null = null) {
    if (!workspace) {
      workspace = this.selectedWorkSpace;
    }
    return _.intersection(workspace?.features || [], features)?.length > 0;
  }

  checkChannelFeatures(features: ChannelFeatures[]) {
    return _.intersection(this.selectedChannel?.features, features)?.length > 0;
  }

  checkPermissions(permissions: EUserPermissions[]) {
    return _.intersection(this.user?.permissions || [], permissions)?.length > 0;
  }

  checkDealerSettingByValue(setting: DealerSettingName, value: string | null): boolean {
    return _.find(this.user?.dealerSettings || [], { key: setting, value: value }) ? false : true;
  }

  checkWorkspaceFeaturesByWorkspace(features: WorkspaceFeatures[], workspace: IWorkspace) {
    if (!workspace) {
      return false;
    }
    return _.intersection(workspace?.features || [], features)?.length > 0;
  }

  getDealerSetting(value: DealerSettingName): IDealerSetting | undefined {
    return this.user?.dealerSettings.find((e) => e.key === value);
  }

  checkCanUseWhatsapp(): boolean {
    if (!this.selectedWorkSpace) {
      return false;
    }
    return (
      (this.selectedWorkSpace.id === 'sales' && this.checkDealerSetting(DealerSettingName.WhatsAppSalesModule)) ||
      (this.selectedWorkSpace.id === 'service' && this.checkDealerSetting(DealerSettingName.WhatsAppServiceModule))
    );
  }
}
